.sliderGroup {
	display: flex;
	justify-content: space-between;
	width: 100%;
	flex-wrap: nowrap;
}

.paddingLeft {
	padding-left: var(--mantine-spacing-xs);
}

.paddingRight {
	padding-right: var(--mantine-spacing-xs);
}

.padding {
	padding: var(--mantine-spacing-xs);
}
